import { useLogoSrc } from './useLogoSrc';

/**
 * The mark followed by the "Waadoo" wordmark, for the open sidebar. The word
 * is plain bold text in the system font (no image, so it stays sharp and
 * follows the theme): dark grey in light mode, light grey in dark mode, from
 * --waadoo-wordmark in styles.css. The image is decorative; the word carries
 * the name for assistive technology.
 */
export const LogoFull = () => {
  const src = useLogoSrc();
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
      <img src={src} style={{ height: 36, width: 36 }} alt="" />
      <span
        style={{
          color: 'var(--waadoo-wordmark)',
          fontFamily: 'var(--bui-font-regular)',
          fontSize: 22,
          fontWeight: 800,
          letterSpacing: '-0.01em',
          lineHeight: 1,
          whiteSpace: 'nowrap',
        }}
      >
        Waadoo
      </span>
    </span>
  );
};
